export const center = ()=>{
    return {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    }
};



// WEBPACK FOOTER //
// ./src/app/style/globalStyles.js